import { textVariants } from "@/src/components/Text/Text";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/shad/select";
import { useWalletData } from "@/src/hooks/useCoinData";
import { Suspense, lazy, useEffect, useState } from "react";
import Tabs from "@/src/components/Tabs/Tabs";
import Loader from "@/src/components/Loader";
import { isEmpty } from "lodash";
import { Button } from "@/src/components/Button/Button";
import useUrlState from "@/src/hooks/use-url-state";
import { useTranslation } from "react-i18next";
import { useQueryState } from "nuqs";

const WalletHistory = lazy(() => import("./components/Wallet"));
const P2PHistory = lazy(() => import("./components/P2p"));
const B2CHistory = lazy(() => import("./components/B2c"));

const History = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.wallet.history.${key}`);
  const [transaction, setTransaction] = useState<string | undefined>("");
  const [coin, setCoin] = useState("");
  const [tab, setTab] = useUrlState<"p2p" | "direct" | "wallet">(
    "tab",
    "wallet"
  );
  const [, setPage] = useQueryState("page");
  const [, setDrop] = useQueryState("drop");

  const { walletData } = useWalletData();

  function clearFilters() {
    window.location.reload();
  }

  useEffect(() => {
    setTransaction("");
    setPage("1");
    setDrop("10");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div>
      <h2 className={textVariants({ size: "xxl", font: "medium" })}>
        {trans("header")}
      </h2>
      <div className="flex">
        <Tabs
          activeTab={tab}
          setTab={setTab}
          tabs={[
            { name: trans("tabs.wallet"), value: "wallet" },
            { name: trans("tabs.p2p"), value: "p2p" },
            { name: trans("tabs.direct"), value: "direct" },
          ]}
        />
      </div>
      <div className=" flex items-center justify-between mt-5">
        <div className="flex items-center gap-5">
          <div>
            <Select
              value={!isEmpty(coin) ? coin : undefined}
              onValueChange={setCoin}
            >
              <SelectTrigger className=" whitespace-nowrap ">
                <SelectValue placeholder={trans("filters.coins.placeholder")} />
              </SelectTrigger>
              <SelectContent>
                {walletData?.wallets?.map((item) => (
                  <SelectItem
                    key={item?.coin__id}
                    value={item?.coin__id.toString()}
                  >
                    <div className="flex items-center gap-1">
                      <img
                        src={item?.image}
                        className="h-4 w-4"
                        alt={item?.label}
                      />
                      <span
                        className={textVariants({
                          size: "sm",
                          variant: "desc",
                          case: "capitalize",
                        })}
                      >
                        {item.label}
                      </span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {tab === "wallet" ? (
            <div>
              <Select
                value={!isEmpty(transaction) ? transaction : undefined}
                onValueChange={setTransaction}
              >
                <SelectTrigger>
                  <SelectValue
                    placeholder={trans("filters.type.placeholder")}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="deposit">
                    {trans("filters.type.values.deposit")}
                  </SelectItem>
                  <SelectItem value="withdraw">
                    {trans("filters.type.values.withdraw")}
                  </SelectItem>
                  <SelectItem value="convert">
                    {trans("filters.type.values.convert")}
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>
          ) : (
            <div>
              <Select
                value={!isEmpty(transaction) ? transaction : undefined}
                onValueChange={setTransaction}
              >
                <SelectTrigger>
                  <SelectValue
                    placeholder={trans("filters.type.placeholder")}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="buy">
                    {trans("filters.type.values.buy")}
                  </SelectItem>
                  <SelectItem value="sell">
                    {trans("filters.type.values.sell")}
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>
          )}
        </div>
        <div>
          <Button
            onClick={clearFilters}
            className="border-solid"
            variant={"filter"}
          >
            {trans("filters.clear")}
          </Button>
        </div>
      </div>
      <div>
        <Suspense fallback={<Loader />}>
          {tab === "wallet" && (
            <WalletHistory coin={coin} trans={transaction} />
          )}
          {tab === "p2p" && <P2PHistory coin={coin} trans={transaction} />}
          {tab === "direct" && <B2CHistory coin={coin} trans={transaction} />}
        </Suspense>
      </div>
    </div>
  );
};

export default History;
